import axios from 'axios'
import { SysVars } from '../main.js'
import { apiORDS, apiORDSapp } from '../shared/api-functions'

// const EXTENSIONA3_ID = 'mfjkeojojhnlcfjjlooeapoinljbfjbf'
// const EXTENSIONA3_ID = 'lhkfmdaljdanjegknbjpcgjjppfhcloc'
// const EXTENSIONA3_ID = 'ahchkdhcpjjafimjljlnghdaofgdhjpe' //OFICIAL ANTERIOR
const EXTENSIONA3_ID = 'epmndncpbbgiclhagbgoienhimkjhdck' //NOVA EXTENSAO

const EXTENSIONSAT_ID = 'loepffieojmppmchmjhiokjmdkffiiin'

const GlobalFunctions = {
  install(Vue) {
    //Vue.prototype.$globalusername = 'TESTE'
    Vue.prototype.$crudText = function(oper) {
      var crudText = ''
      if (oper == SysVars.crudI) {
        crudText = 'Incluir'
      } else if (oper == SysVars.crudU) {
        crudText = 'Alterar'
      } else if (oper == SysVars.crudD) {
        crudText = 'Excluir'
      } else if (oper == SysVars.crudC) {
        crudText = 'Cancelar'
      }
      return crudText
    },

      //
      //
      // TRATAMENTO DE ERRO DAS REQUISICOES API
      //
      //

      Vue.prototype.$restRegisterInterceptor = function(entity) {

        axios.interceptors.request.use((config) => {
          let token = this.$store.getters.getEnv.token
          let uuid = this.$store.getters.getEnv.uuid
          if (token) {
            if (!config.url.includes('htmlpdf') && !config.url.includes('s3.amazon') && !config.url.includes('localhost')) {
              config.headers['Authorization'] = `Bearer ${token}`
              config.headers['uuid'] = `${uuid}`
            }
            // config.headers['Access-Control-Allow-Headers'] = '*'
            // config.headers['Access-Control-Allow-Origin'] = '*'
            //config.headers['Accept'] = 'application/json'
            //config.headers['Authorization'] = `Basic  c2NvdHQ6dGlnZXI=`
          }
          return config
        })

        axios.interceptors.response.use((response) => {
          return response;
        }, err => {
          // console.log(err.response)
          if (err.response && err.response.status === 400 && err.response.data && err.response.data.errmessages) {
            //tratamento de erros enviados pela API (err.response.data.errmessages)
            SysVars.serverErrorStatus = 0
            
            let errMsg = err.response.data.errmessages[0];
            try {
              // Check if the error message is a JSON string and parse it to extract the description
              if (errMsg && (errMsg.startsWith('{') || errMsg.startsWith('['))) {
                const parsed = JSON.parse(errMsg);
                if (parsed) {
                  if (parsed.reponse_data && parsed.reponse_data.errors && parsed.reponse_data.errors[0] && parsed.reponse_data.errors[0].description) {
                    errMsg = parsed.reponse_data.errors[0].description;
                  } else if (parsed.errors && parsed.errors[0] && parsed.errors[0].description) {
                    errMsg = parsed.errors[0].description;
                  } else if (parsed.error) {
                    errMsg = parsed.error;
                  }
                }
              }
            } catch (e) {
              // Ignore parsing errors, display errMsg as plain text
            }
            
            SysVars.serverErrorText = errMsg
            SysVars.serverError = true
          }
          else
            if (err.response && err.response.status === 400 && err.response.data && err.response.data.message) {
              SysVars.serverErrorStatus = 0
              SysVars.serverErrorText = err.response.data.message
              SysVars.serverError = true
            }
            else
              if (err.response && err.response.status === 401) {
                //401 unauthorized
                SysVars.appLogged = false
              }
              else
                if (err.response) {
                  const error = err.response;
                  //400 bad request
                  //403 forbidden
                  //404 not found
                  //500 erro interno servidor
                  SysVars.serverErrorStatus = error.status
                  SysVars.serverErrorText = error.statusText
                  SysVars.serverError = true
                  //if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
                  //    console.log('unauthorized, logging out ...');
                  //    auth.logout();
                  //    router.replace('/auth/login');
                  //}
                } else {
                  //network error
                  SysVars.serverErrorStatus = ''
                  SysVars.serverErrorText = 'Erro na conexão com o servidor. Verifique a rede e tente novamente.'
                  SysVars.serverError = true
                }
          this.$appLoading(false)
          return Promise.reject(err)
        })
      },

      //
      //
      // MENSAGEM DE ERRO E NOTIFICACOES
      //
      //

      Vue.prototype.$appLoading = function(value) {
        SysVars.appLoading = value
      },

      Vue.prototype.$serverError = function(value) {
        SysVars.serverError = value
      },

      Vue.prototype.$showMessage = function(title, message, kind) {
        SysVars.appMessage = message
        SysVars.appTitleMessage = title
        SysVars.kindMessage = kind
        SysVars.appShowMessage = true
      },

      Vue.prototype.$erpToastSuccess = function(message) {
        SysVars.toastSuccess = message //exibe a notificacao pelo watch no app.vue
      },

      Vue.prototype.$erpToastDeleted = function() {
        SysVars.toastSuccess = 'O registro foi excluído.'
      },

      Vue.prototype.$erpToastUpdated = function() {
        SysVars.toastSuccess = 'O registro foi alterado.'
      },

      Vue.prototype.$erpToastInserted = function() {
        SysVars.toastSuccess = 'O registro foi inserido.'
      },

      Vue.prototype.$erpToastWarning = function(message) {
        SysVars.toastWarning = message //exibe a notificacao pelo watch no app.vue
      },

      Vue.prototype.$erpToastError = function(message) {
        SysVars.toastError = message //exibe a notificacao pelo watch no app.vue
      },

      //Vue.prototype.$erpToastConfirm = function (title, message, teste) {
      //var buttons = [
      //    {text: 'Depois', action: (toast) => {console.log('Clicked: Later'); this.$snotify.remove(toast.id); } },
      //    {text: 'Fechar', action: (toast) => {console.log('Clicked: No'); this.$snotify.remove(toast.id); this.closeForm() }, bold: true},
      //]
      //this.$erpToastConfirm('Example body', 'teste', buttons)
      //  this.$snotify.confirm(message, title, { buttons: teste })
      //},

      //Vue.prototype.$erpToastClose2 = function (title, message, form) {
      //    this.$snotify.confirm(message, {
      //    buttons: [
      //      {text: 'Depois', action: (toast) => {console.log('Clicked: Later'); this.$snotify.remove(toast.id); } },
      //      {text: 'Fechar', action: (toast) => {console.log('Clicked: No'); this.$snotify.remove(toast.id); form.closeForm() }, bold: true},
      //    ]
      //  })
      //},


      //
      //
      //TELA
      //
      //
      Vue.prototype.$scrollTo = function(top) {
        window.scrollTo({
          top: top,
          left: 0,
          behavior: 'smooth'
        })
      },

      Vue.prototype.$modalForm = function(value) {
        if (value)
          document.body.classList.add('no-scroll')
        else
          document.body.classList.remove('no-scroll')
      },

      Vue.prototype.$disableScroll = function(value) {
        if (value)
          document.body.classList.add('no-scroll')
        else
          document.body.classList.remove('no-scroll')
      },


      //
      //
      //VERIFICACAO DE CERTIFICADO
      //
      //

      Vue.prototype.$certificadoCheck = function(codfil) {
        //RETORNA O TIPO DE CERTIFICADO CONFIGURADO NA FILIAL - UTILIZADO PARA ENVIO DA NFE

        //VERIFICA A LISTA DE CERTIFICADOS DA SESSAO
        if (!this.$store.getters.getSessao || this.$store.getters.getSessao.certificado.length == 0) {
          this.$store.dispatch('loadSessao', this)
          this.$erpToastError('Nenhum certificado foi localizado')
          return ''
        }

        let certificado = null;

        if (codfil) {
          certificado = this.$store.getters.getSessao.certificado.filter(function(cert) {
            return cert.codfil == codfil
          })
        } else {
          certificado = this.$store.getters.getSessao.certificado
        }
        //

        //SE NAO ENCONTRAR O CERTIFICADO DA FILIAL, REDIRECIONA PARA INSTALACAO
        if (!certificado || certificado.length == 0) {
          this.$erpToastError('Vincule um certificado digital para continuar')
          if (this.$router) {
            this.$router.push(codfil ? ('/certificado/' + codfil) : '/certificado').catch(() => {})
          }
          return ''
        }

        if (certificado[certificado.length - 1].tpcertificado == 'A1') {
          return 'A1'
        }

        //EFETUA A VERIFICACAO DA EXTENSAO SE ESTÁ INSTALADA
        if (!chrome) {
          this.$erpToastError('Certificado digital A3 homologado apenas no Chrome')
          return ''
        }
        chrome.runtime.sendMessage(EXTENSIONA3_ID, 'version', response => {
          console.log(response)
          if (!response || response.version != '1.3') {
            this.$erpToastError('Extensão do chrome não foi encontrada. Reconfigure o certificado A3.')
            this.$router.push('/certificado/extension') //ENVIA PARA A TELA DE CONFIGURACAO DO CERTIFICADO
          }
        })

        return 'A3'
      },


      Vue.prototype.$executaExtensaoChromeSAT = async function(codnf, servico, responseCallback, paramsinut) {
        //CHAMADA DA EXTENSAO PARA ENVIO DA NFE
        let token = this.$store.getters.getEnv.token
        let uuid = this.$store.getters.getEnv.uuid
        let params = 'uuid=' + uuid + '&servico=' + servico + '&token=' + token
        if (codnf)
          params = params + '&codnf=' + codnf

        const result = await apiORDS(this.$store.getters.urlOrds + 'cg/ambientenfe', null, true);

        if (result)
          SysVars.ambienteHomologacaoNFe = result.homologacao
        else
          SysVars.ambienteHomologacaoNFe = null




        let servidor = '1'
        if (SysVars.ambienteHomologacaoNFe) {
          servidor = '2'
          params = params + '&swcnpj=16716114000172'
        }
        params = params + '&servidor=' + servidor

        if (paramsinut)
          params = params + paramsinut

        this.$appLoading(true)
        var self = this

        //console.log(params)

        chrome.runtime.sendMessage(EXTENSIONSAT_ID, params, response => {
          self.$appLoading(false)
          if (!response || response.status != 'success') {
            if (response.status == 'update') {
              self.$erpToastError('É necessário atualizar a versão do módulo SAT')
              self.$router.push('/certificado/extension') //ENVIA PARA A TELA DE CONFIGURACAO DO CERTIFICADO
            } else if (response.status != 'success') {
              self.$erpToastError(response.message)
            }
            return
          } else {
            responseCallback(response)
          }
        })

      },

      Vue.prototype.$executaExtensaoChromeA3 = function(codnf, servico, responseCallback, paramsinut) {
        //CHAMADA DA EXTENSAO PARA ENVIO DA NFE
        let token = this.$store.getters.getEnv.token
        let uuid = this.$store.getters.getEnv.uuid
        let params = 'uuid=' + uuid + '&servico=' + servico + '&token=' + token
        if (codnf)
          params = params + '&codnf=' + codnf

        if (paramsinut)
          params = params + paramsinut

        this.$appLoading(true)
        var self = this

        console.log(params)

        chrome.runtime.sendMessage(EXTENSIONA3_ID, params, response => {
          console.log(response)
          self.$appLoading(false)
          if (!response || response.status != 'success') {
            if (response.status == 'update') {
              self.$erpToastError('É necessário atualizar a versão do módulo A3')
              self.$router.push('/certificado/extension') //ENVIA PARA A TELA DE CONFIGURACAO DO CERTIFICADO
            } else if (response.status != 'success') {
              self.$erpToastError(response.message)
            }
            return
          } else {
            responseCallback(response)
          }
        })

      },


      Vue.prototype.$checkExtensaoChromeA3 = function(responseCallback) {
        //CHECA SE A EXTENSAO ESTÁ INSTALADA
        chrome.runtime.sendMessage(EXTENSIONA3_ID, 'version', responseCallback)
      },


      Vue.prototype.$certificadoTesteA3 = function(responseCallback) {
        //EFETUA O TESTE NO CERTIFICADO A3
        chrome.runtime.sendMessage(EXTENSIONA3_ID, 'servico=teste', responseCallback)
      },


      //
      //
      //
      //
      //
      //
      Vue.prototype.$SATExtension = function(xml, responseCallback) {
        //CHAMADA DA EXTENSAO PARA EMISSAO DO SAT
        chrome.runtime.sendMessage(EXTENSIONSAT_ID, xml, responseCallback)
      },



      //
      //
      // CONVERSÕES
      //
      //

      Vue.prototype.$strToFloat = function(value, dec) {
        let decimal = 0
        if (Number.isInteger(dec)) {
          decimal = dec;
        }
        let v = value
        if (v == '' || v == null)
          v = ''
        else
          if (!this.$isValidFloat(v)) {
            if (parseFloat(v)) {
              v = parseFloat(v).toFixed(decimal);
              return v
            } else {
              v = ''
            }
          }
        if (v) {
          if (v && v.length) {
            v = v.replace(',', '.');
          } else {
            v = parseFloat(v).toFixed(decimal);
          }
        }
        return v;
      },

      Vue.prototype.$floatToStr = function(value, dec) {
        let v = value
        if (v == null) {
          v = 0
        }
        v = parseFloat(v).toFixed(dec);
        v = v.replace('.', ',')//.toLocaleString('pt-BR')
        return v;
      },

      Vue.prototype.$removerAcentos = function(s) {
        var map = { "â": "a", "Â": "A", "à": "a", "À": "A", "á": "a", "Á": "A", "ã": "a", "Ã": "A", "ê": "e", "Ê": "E", "è": "e", "È": "E", "é": "e", "É": "E", "î": "i", "Î": "I", "ì": "i", "Ì": "I", "í": "i", "Í": "I", "õ": "o", "Õ": "O", "ô": "o", "Ô": "O", "ò": "o", "Ò": "O", "ó": "o", "Ó": "O", "ü": "u", "Ü": "U", "û": "u", "Û": "U", "ú": "u", "Ú": "U", "ù": "u", "Ù": "U", "ç": "c", "Ç": "C" }
        return s.replace(/[\W\[\] ]/g, function(a) { return map[a] || a })
      },

      Vue.prototype.$getDate = function() {
        //RETORNA A DATA ATUAL NO FORMATO YYYY-MM-DD
        var d = new Date()

        var month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear()

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
      },

      Vue.prototype.$strToDate = function(dateStr) {
        if (dateStr == null) {
          return null
        }
        const [year_, month_, day_] = dateStr.split("-")
        var day = day_.substr(0, 2)
        var d = new Date(year_, month_ - 1, day)
        return d
        // var month = '' + (d.getMonth() + 1),
        // day = '' + d.getDate(),
        // year = d.getFullYear()
        // if (month.length < 2) month = '0' + month;
        // if (day.length < 2) day = '0' + day;
        // return [year, month, day].join('-');
      },
      Vue.prototype.$addDays = function(dateStr, days) {
        let nDays = 0
        nDays = parseFloat(days)

        // console.log('entrada: ' + dateStr)
        const [year_, month_, day_] = dateStr.split("-")

        if (isNaN(nDays)) {
          return dateStr
        }
        var day = day_.substr(0, 2)
        var d = new Date(year_, month_ - 1, day)
        d.setDate(d.getDate() + nDays)
        // console.log('saida:' + d.toString())
        var month = '' + (d.getMonth() + 1)
        day = '' + (d.getDate() + 0)
        //day = '' + (d.getDate() + 1)
        var year = d.getFullYear()
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');

      },
      Vue.prototype.$addMonths = function(dateStr, months) {
        const [year_, month_, day_] = dateStr.split("-")
        var day = day_.substr(0, 2)
        var d = new Date(year_, month_ - 1, day)
        d.setMonth(d.getMonth() + months)
        var month = '' + (d.getMonth() + 1)
        day = '' + d.getDate()
        var year = d.getFullYear()
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
      },
      Vue.prototype.$lastDay = function(dateStr) {
        const [year_, month_, day_] = dateStr.split("-")
        var d = new Date(year_, month_, 0)
        var last = new Date(d.getFullYear(), d.getMonth() + 1, 0), day = last.getDate(), year = last.getFullYear(), month = last.getMonth()
        month++
        if (String(month).length < 2) month = '0' + month;
        if (String(day).length < 2) day = '0' + day;
        return [year, month, day].join('-');
      },
      Vue.prototype.$firstDay = function(dateStr) {
        const [year_, month_, day_] = dateStr.split("-")
        var day = '' + 1
        var month = '' + month_
        var year = year_
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
      },



      Vue.prototype.$daysBetween = function(first, second) {
        if (!first || !second || typeof first !== 'string' || typeof second !== 'string') {
          return 0
        }
        const fParts = first.split("-")
        const sParts = second.split("-")
        if (fParts.length < 3 || sParts.length < 3) {
          return 0
        }
        const [yearf_, monthf_, dayf_] = fParts
        var dayf = dayf_.substr(0, 2)
        var df = new Date(yearf_, monthf_ - 1, dayf)
        const [years_, months_, days_] = sParts
        var days = days_.substr(0, 2)
        var ds = new Date(years_, months_ - 1, days)
        df.setMinutes(df.getMinutes() - df.getTimezoneOffset());
        ds.setMinutes(ds.getMinutes() - ds.getTimezoneOffset());

        var millisecondsPerDay = 24 * 60 * 60 * 1000;

        return (ds - df) / millisecondsPerDay;
      },

      //
      //
      // FORMATACAO DE CAMPOS
      //
      //

      Vue.prototype.$formatFone = function(value) {
        if (!value) {
          return value
        }
        let t = value.length
        if (t == 8) {
          return value.replace(/\D/g, '').replace(/^(\d{4})(\d{4})??/, "$1-$2")
        } else
          if (t == 9) {
            return value.replace(/\D/g, '').replace(/^(\d{1})(\d{4})(\d{4})??/, "$1 $2-$3")
          } else
            if (t == 11) {
              return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1})(\d{4})(\d{4})??/, "($1) $2 $3-$4")
            } else
              if (t == 10) {
                return value.replace(/\D/g, '').replace(/^(\d{2})(\d{4})(\d{4})??/, "($1) $2-$3")
              } else {
                return value
              }
      },
      Vue.prototype.$formatCNPJCPF = function(value) {
        if (!value) {
          return value
        }
        if (value.length == 14) {
          return value.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5")
        }
        if (value.length == 11) {
          return value.replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4")
        } else {
          return value
        }
      },
      Vue.prototype.$formatCNPJ = function(value) {
        if (!value) {
          return value
        }
        if (value.length == 14) {
          return value.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5")
        } else { return value }
      },
      Vue.prototype.$formatCPF = function(value) {
        if (!value) {
          return value
        }
        if (value.length == 11) {
          return value.replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4")
        } else {
          return value
        }
      },
      Vue.prototype.$formatDate = function(value) {
        if (!value) {
          return value
        }
        if (value.length == 8) {
          return value.replace(/^(\d{2})?(\d{2})?(\d{4})?/, "$1/$2/$3")
        } else {
          return value
        }
      },
      Vue.prototype.$formatHora = function(value) {
        if (!value) {
          return value
        }
        let t = value.length
        if (t == 4)
          return value.replace(/\D/g, '').replace(/^(\d{2})(\d{2})??/, "$1:$2")
        else
          return value
      },

      /* SUBSTITUIDO POR UTILS.FORMATVALUE
      Vue.prototype.$formatValue = function(value, precision) {
        var numero = 0;
        if (value != null) {
          numero = value
        }
        numero = parseFloat(numero).toFixed(precision).split('.')
        numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.')
        return numero.join(',')
      },
      */

      //
      //
      // VALIDACOES
      //
      //

      //VALORES
      Vue.prototype.$isValidFloat = function(value) {
        if (Number(value))
          return true
        else
          if (value.match(/^[0-9,]+$/)) {
            return true;
          } else {
            return false;
          }
      },
      //EMAIL
      Vue.prototype.$isValidEmail = function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      },
      //DATAS
      Vue.prototype.$isValidDate = function(pDate) {
        var vdata = pDate;
        var vday = vdata.substring(0, 2);
        var vmonth = vdata.substring(3, 5);
        var vyear = vdata.substring(6, 10);

        if (vday == "") {
          return false;
        }
        if (vmonth == "") {
          return false;
        }
        if (vyear == "") {
          return false;
        }

        day = parseInt(vday);
        month = parseInt(vmonth);
        year = parseInt(vyear);

        if (day < 1 || day > 31) {
          return false;
        }
        if (month < 1 || month > 12) {
          return false;
        }
        if (year < 1900) {
          return false;
        }

        // Valindao mes com 31 dias
        if ((month == 1) || (month == 3) || (month == 5) || (month == 7) || (month == 8) || (month == 10) || (month == 12)) {
          if ((day < 1) || (day > 31)) {
            return false;
          }
        } else {
          // Valindado mes com 30 dias
          if ((month == 4) || (month == 6) || (month == 9) || (month == 11)) {
            if ((day < 1) || (day > 30)) {
              return false;
            }
          } else
            // Valindado Feveiro no ano bixsexto
            if ((month == 2)) {
              if ((year % 4 == 0) && ((year % 100 != 0) || (year % 400 == 0))) {
                if ((day < 1) || (day > 29)) {
                  return false;
                }
              } else {
                if ((day < 1) || (day > 28)) {
                  return false;
                }
              }
            }
        }
        return true;
      },

      //validacao de CNPJ
      Vue.prototype.$isValidCNPJ = function(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj == '') return false;

        if (cnpj.length != 14)
          return false;

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
          cnpj == "11111111111111" ||
          cnpj == "22222222222222" ||
          cnpj == "33333333333333" ||
          cnpj == "44444444444444" ||
          cnpj == "55555555555555" ||
          cnpj == "66666666666666" ||
          cnpj == "77777777777777" ||
          cnpj == "88888888888888" ||
          cnpj == "99999999999999")
          return false;

        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
            pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
          return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
            pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
          return false;

        return true;
      },

      Vue.prototype.$apiGuiaUsuarioDesativar = async function() {
        //RETIRA O GUIA INICIAL NO PROXIMO LOGIN
        await apiORDSapp(this, "usuario/guia/", "post", null);
        SysVars.guia = false;
      }

  }

}

export default GlobalFunctions




// WEBPACK FOOTER //
// ./src/global/global-functions.js